/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetAttachedDocumentsResponseJson } from './get-attached-documents-response-json';
import { GetAttachedDocumentsResult } from '../results/get-attached-documents-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { AttachedDocumentTypeDto } from '../models/attached-document-type-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetAttachedDocumentsResponse extends ResponseWithErrorGeneric<GetAttachedDocumentsResponseJson, GetAttachedDocumentsResult> implements IResponseWithErrorGeneric<GetAttachedDocumentsResult> {
  public attachedDocumentTypes: AttachedDocumentTypeDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetAttachedDocumentsResponse>) {
    super(response, GetAttachedDocumentsResult.Error);
    if (this.result !== GetAttachedDocumentsResult.Success) {
      return;
    }

    this.attachedDocumentTypes = this.body.attachedDocumentTypes;
  }
  //</custom-body>
}
